<!-- ***Designed by Salman Rifai***** -->
<!-- ***CP-214*** -->

<!-- Hello Generic field -->
 <div title="{{searchStr | translate}}">
<div class="dhl-field-autocomplete-v2" [hidden]="frmGroup.get(this.configData.name)['hidden']" [formGroup]="frmGroup">
    <div class="form-field-wrapper" [ngClass]="{'typing':typing, 'margin-30px' :configData['outsideLabel']}">
        <div class="form-field-control" #formControl
            [ngClass]="{'error': (frmGroup.get(configData.name).errors && frmGroup.get(configData.name).touched && !frmGroup.get(configData.name).valid), 'inputwithToggle': configData['switchUrlFlag']}">
            <input appFormFieldAutocompleteV2 #inputEle type="{{fieldType}}" class="base-field" autocomplete="off"
                [attr.data-placeholder]="placeholder | translate" [required]="configData.required"
                [formControlName]="$safeNavigationMigration(configData?.name)" [formControl]="frmGroup.get(configData.name)"
                [(ngModel)]="searchStr" (keyup)="onkeyupHandler($event)" (click)="setOnFocus($event)"
                (change)="controlValueChange($event)" [ngClass]="{'base-field-height': (configData['customHeight'] || configData['customHeight'] === 'true'), 'base-field-height-readonly': configData['readonly'], 'pointer': configData['cursor'] === true}"/>
            <span class="form-field-label">
                <label class="base-label"> {{$safeNavigationMigration(configData?.label) | translate}}<span *ngIf="configData?.required || frmGroup.get(configData.name)['required']"> *</span> </label>
            </span>
            <div class="cancel" *ngIf="configData['isCancelbtn']"><img
                src="../../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,30,24,24))" (click)="ClearLocationSearch( this.frmGroup.get(this.configData.name).value)" />
              </div>
            <span class="toggleInRight" *ngIf="configData['switchUrlFlag']">
                <span class="default-icon">
                    <img title="{{configData['switchUrlTitle']}}" src="../../../../assets/images/cox-icons/icons-table-listing.svg#svgView(viewBox(0,2260,24,24))"
                        style="width:20px;height:20px" type="image/svg+xml" />
                </span>
                <span class="toggle-button-outer togglegroup">
                    <label class="dhl-switch-v2">
                    <input type="checkbox" [checked]="controlUrlFlag" (change)="toggleUrl($event)" [disabled] = "disableSwitch">
                    <span class="dhl-slider-v2 dhl-round-v2"> </span>
                    </label>
                </span>
            </span>
            <span *ngIf="fieldIcon" class="field-icon" (click)="popFieldAction($event)">
                <span class="default-icon">
                    <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,662,20,20))"
                        style="width:20px;height:20px" type="image/svg+xml" />
                </span>
                <span class="active-icon">
                    <img src="../../../../../assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,692,20,20))"
                        style="width:20px;height:20px" type="image/svg+xml" />
                </span>
            </span>
        </div>
        <div *ngIf="progressBar" class="search-result spinner">
            <app-progress-spinner-v2></app-progress-spinner-v2>
        </div>
        <div *ngIf="!progressBar && !suggestionList.length && addNewSuggestion" class="search-result">
            <div class="suggestion-list">
                <div (click)="AddNewSuggestion($event)">
                    <a class="list-items" >
                        <span class="suggestion-item" style="display: inline;flex-direction: column;">
                            <span>
                                {{configData['addNewSugessionLabel']}}
                            </span>
                        </span>
                    </a>
                </div>
               
            </div>
        </div>
        <div *ngIf="typing && (suggestionList)?.length > 0" class="search-result">
            <div class="suggestion-list" [ngClass]="{'disabled':suggestion.disable}"
                *ngFor="let suggestion of suggestionList ">
                <a class="list-items" (click)="selectItem($event,suggestion, suggestion.disable)">
                    <div fxFlex="0 0 40px">
                        <mat-icon color="accent">ballot</mat-icon>
                    </div>
                    <ng-container *ngIf="autoCompleteMetaData['primaryText'].length > 0;else simpleValue">
                        <span class="primary-label" style="display: inline-flex;flex-direction: column;">
                            <span [innerHTML]="suggestion.address2 ? getMultipleAddress(suggestion) : suggestion.primaryText">
                            </span>
                        </span>
                    </ng-container>
                    <ng-template #simpleValue>
                        <span class="primary-label" style="display: inline-flex;flex-direction: column;">
                            <span>
                                {{  suggestion  }}
                            </span>
                        </span>
                    </ng-template>
                    <ng-container
                        *ngIf="autoCompleteMetaData['secondaryText'] && autoCompleteMetaData['secondaryText'].length > 0">
                        <span class="secondary-label">
                            {{suggestion[autoCompleteMetaData['secondaryText'][0]]}} ,
                            {{suggestion[autoCompleteMetaData['secondaryText'][1]]}}
                        </span>
                    </ng-container>
                </a>
            </div>
            <div *ngIf="addNewSuggestion" (click)="AddNewSuggestion($event)">
                <a class="list-items" >
                    <span class="suggestion-item" style="display: inline;flex-direction: column;">
                        <span>
                            {{configData['addNewSugessionLabel']}}
                        </span>
                    </span>
                </a>
            </div>
        </div>
        
        <div class="form-field-error"  
            [ngClass]="{'hide-error': !(frmGroup.get(configData.name).errors && (frmGroup.get(configData.name).touched ||frmGroup.get(configData.name).value) && !frmGroup.get(configData.name).valid)}">
            <span class="error-icon">
                <img class="dhl-input-error-icon"
                    src="/assets/images/cox-icons/form-icons.svg#svgView(viewBox(0,60,24,24))">
            </span>
            <span class="error-text" *ngIf="frmGroup.get(configData.name).errors">
                <span *ngIf="frmGroup.get(configData.name).errors.required">{{ enum.Required_Validation | translate }}</span>
                <span *ngIf="frmGroup.get(configData.name).errors.NoItemFound">{{ enum.NoRecordFound_Validation | translate }}</span>
                <span *ngIf="frmGroup.get(configData.name).errors.selectFromList">{{ enum.SelectFromList_Validation | translate }}</span>
            </span>
        </div>

        <!-- Cp-4624 -start -->
        <div class="form-field-hint" *ngIf="configData?.hintText"
            [ngClass]="{'cover-error-space': !(frmGroup.get(configData.name).errors && (frmGroup.get(configData.name).touched ||frmGroup.get(configData.name).value) && !frmGroup.get(configData.name).valid)}">
            <span class="hint" >{{configData.hintText}}</span>
        </div>
        <!-- Cp-4624 -end -->
    </div>
</div>